import { render, staticRenderFns } from "./remarkDialog.vue?vue&type=template&id=1fbd5c98&scoped=true"
import script from "./remarkDialog.vue?vue&type=script&lang=js"
export * from "./remarkDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbd5c98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fbd5c98')) {
      api.createRecord('1fbd5c98', component.options)
    } else {
      api.reload('1fbd5c98', component.options)
    }
    module.hot.accept("./remarkDialog.vue?vue&type=template&id=1fbd5c98&scoped=true", function () {
      api.rerender('1fbd5c98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/receivableManagementSite/aRGenerationNew/cmp/Dialog/remarkDialog.vue"
export default component.exports